import React from 'react';

type JsonLdProps = {
  data: Record<string, any>;
};

const JsonLd: React.FC<JsonLdProps> = ({ data }) => {
  // Escape dangerous sequences to prevent XSS attacks via script tag injection
  const escapedJson = JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');
  
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: escapedJson }}
    />
  );
};

export default JsonLd;
